import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { UnidadeMedida } from '../../types/aquisicao';
import { unidadesMedidaService } from '../../services';

const fields: ResourceField<UnidadeMedida>[] = [
  { name: 'codigo', label: 'Código', required: true },
  { name: 'descricao', label: 'Descrição', required: true },
  { name: 'fator_para_ton', label: 'Fator para ton', type: 'number' },
];

export const UnidadesMedidaFormPage: React.FC = () => (
  <ResourceFormPage
    title="Unidade de medida"
    description="Cadastre unidades de medida."
    fields={fields}
    service={unidadesMedidaService}
    redirectPath="/admin/parametros/unidades-medida"
    cancelPath="/admin/parametros/unidades-medida"
  />
);
